import { render } from "./checklist_weightings.html?vue&type=template&id=bddf8028&external"
import script from "./checklist_weightings.js?vue&type=script&lang=js&external"
export * from "./checklist_weightings.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__